import script from "./submitRecord.vue?vue&type=script&setup=true&lang=js"
export * from "./submitRecord.vue?vue&type=script&setup=true&lang=js"

import "./submitRecord.vue?vue&type=style&index=0&id=03f90b54&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03f90b54"]])

export default __exports__